// BackEnd.jsx
import SkillCard from './SkillCard';

const BackEnd = () => {
  const backendSkills = [
    {
      name: 'Python',
      icon: 'bx bxl-python',
      frameworks: [
        { name: 'Django', icon: 'bx bxl-django' },
        { name: 'Flask', icon: 'bx bxl-flask' },
      ]
    },
    {
      name: 'Node.js',
      icon: 'bx bxl-nodejs',
      frameworks: [
        { name: 'Express.js', icon: 'devicon-express-original' },
        { name: 'NestJS', icon: 'devicon-nestjs-original' }
      ]
    },
    { name: 'C++', icon: 'devicon-cplusplus-plain' },
    { name: 'RESTful APIs', customImg: 'https://www.javacodegeeks.com/wp-content/uploads/2024/01/rest-api-icon.png' },
    { name: 'Clean Architecture', icon: 'bx bx-layer' },
    { name: 'JWT & OAuth2', customImg: 'https://img.icons8.com/?size=512&id=rHpveptSuwDz&format=png' },
    { name: 'API Security', icon: 'bx bx-shield' },
    { name: 'Testing', icon: 'bx bx-test-tube' },
  ];

  return (
    <div className="skills__content">
      <div className="skills__content-header">
        <h3 className="skills__title">Backend Development</h3>
        <p className="skills__description">Server-side development, APIs & architecture</p>
      </div>
      <div className="skills__grid">
        {backendSkills.map((skill, index) => (
          <SkillCard
            key={index}
            name={skill.name}
            icon={skill.icon}

            customImg={skill.customImg}
            frameworks={skill.frameworks}
          />
        ))}
      </div>
    </div>
  );
};

export default BackEnd;
